module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO ID_DESTAQUES-f3cb0c31a86f24da8620f5eff102968a.png";